import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useCustomerType } from '../../hooks/CompanyConfiguration/useCustomerType'
import AddCustomerType from './AddCustomerType'

export default function EditCustomerType() {
  const { customerType, getCustomerType } = useCustomerType()
  const params = useParams()
  useEffect(() => {
    getCustomerType({ customerTypeId: params.customerTypeId })
  }, [params.customerTypeId])

  return <> {customerType ? <AddCustomerType customerType={customerType} /> : <Loader />} </>
}
